import React from 'react';
import { MenuItem } from '@mui/material';
import { IoMdCheckmark } from 'react-icons/io';

interface IgnoreReportFilterMenuItemProps {
  isChecked: boolean;
  onClick: (e: React.MouseEvent<HTMLLIElement>) => void;
  optionName: string;
  isDisabled: boolean;
  menuStyle: React.CSSProperties;
}

const IgnoreReportFilterMenuItem: React.FC<IgnoreReportFilterMenuItemProps> = ({
  isChecked,
  onClick,
  optionName,
  isDisabled,
  menuStyle,
}) => {
  return (
    <div style={{ display: "flex" }}>
      <span
        style={{
          color: "rgb(211, 211, 211)",
          paddingLeft: "5px",
          paddingTop: "4px",
          position: "absolute",
        }}
      >
        {isChecked ? <IoMdCheckmark style={{ color: "#7c7979" }} /> : null}
      </span>
      <MenuItem
        onClick={onClick}
        disabled={isDisabled}
        sx={{
          ...menuStyle,
          width: "100%",
        }}
      >
        {optionName}
      </MenuItem>
    </div>
  );
};

export default IgnoreReportFilterMenuItem;
